import { joinChannel } from "@finos/fdc3"
import { combineKeys } from "@react-rxjs/utils"
import { lazy, useEffect } from "react"
import { useTranslation } from "react-i18next"
import { merge } from "rxjs"
import { map } from "rxjs/operators"

import { RegionWrapper } from "@/components/layout/Region"
import { Loader } from "@/components/Loader"
import { currencyPairs$ } from "@/services/currencyPairs"
import { getHistoricalPrices$, getPrice$ } from "@/services/prices"

const LiveRatesCore = lazy(() => import("./LiveRatesCore"))

currencyPairs$.subscribe()
combineKeys(currencyPairs$.pipe(map(Object.keys)), (symbol: string) =>
  merge(getHistoricalPrices$(symbol), getPrice$(symbol)),
).subscribe()

const RatesLoader = () => {
  const { t } = useTranslation()
  return (
    <Loader
      ariaLabel={t("liveRates.loadingFXRates")}
      minWidth="22rem"
      minHeight="22rem"
    />
  )
}

export const LiveRates = () => {
  useEffect(() => {
    if (window.fdc3) joinChannel("green")
  }, [])

  return (
    <RegionWrapper fallback={<RatesLoader />}>
      <LiveRatesCore>
        <RatesLoader />
      </LiveRatesCore>
    </RegionWrapper>
  )
}

export default LiveRates
